import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Row, Col, Form } from 'react-bootstrap';

import { Http } from '../../../../../../support';
import { FormControl } from '../../../../../../facturotopia';
import LoadingButton from '../../../../../../facturotopia/LoadingButton';
import DecimalForConceptos from '../../../../support/impuestos/DecimalForConceptos';

const SearchStampingInvoiceForm = (props) => {
  const [state, setState] = useState({
    busy: false,
  });
  const [data, setData] = useState({});

  const rules = {
    cfdi_uuid: ['uuid', 'min:36'],
  };
  const validate = (data) => {
    const validator = new Validator(data, rules);

    validator.check();

    setState({
      ...state,
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    const validator = validate(newData);

    setData({
      ...newData,
    });

    !!newData.cfdi_uuid && validator.passes() && handleOnSearch(newData.cfdi_uuid);
  };

  const handleOnSearch = async (cfdiUuid) => {
    try {
      setState({
        ...state,
        busy: true,
      });

      const params = {
        include: 'input',
      };

      const response = await Http.get(`/api/comprobantes/${cfdiUuid}`, { params });

      let data = response.data.input;

      const metadata = data.Metadata;

      data.UUID = cfdiUuid;
      data.FactorajeFinanciero = response.data.FactorajeFinanciero;

      if (!!metadata.Decimales) {
        data.Decimales = metadata.Decimales;

        DecimalForConceptos.decimales = parseInt(metadata.Decimales);
      }

      props.onChange(data);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No fue posible leer tu factura. =(',
      });
    } finally {
      setState({
        ...state,
        busy: false,
      });
    }
  };

  const { busy, isValid } = state;

  return (
    <Row>
      <Col
        sm="12"
        md="8"
      >
        <FormControl
          type="text"
          label="Folio Fiscal"
          name="cfdi_uuid"
          placeholder="a43dfbe1-00c5-4f93-94ce-848bd819b7ff"
          help=""
          autoFocus
          rules={rules.cfdi_uuid}
          value={data.cfdi_uuid}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm="12"
        md="4"
      >
        <Form.Label className="d-block">&nbsp;</Form.Label>
        <LoadingButton
          className="mr-3"
          variant="primary"
          loading={busy}
          disabled={busy || !data.cfdi_uuid || !isValid}
          onClick={handleOnSearch.bind(this, data.cfdi_uuid)}
        >
          {busy ? 'Buscando...' : 'Buscar'}
        </LoadingButton>
      </Col>
    </Row>
  );
};

export default SearchStampingInvoiceForm;
